import { render, staticRenderFns } from "./TripShareSectionCanEdit.vue?vue&type=template&id=a526c664"
import script from "./TripShareSectionCanEdit.vue?vue&type=script&setup=true&lang=ts"
export * from "./TripShareSectionCanEdit.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports